module.exports = __webpack_public_path__ + "img/creative-commons-pd-alt.9d9b8eab.svg";